import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

const Unauthorized = () => {
  return (
    <Box sx={{
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      p: 3
    }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
        Yetkisiz Erişim
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Bu sayfaya erişim yetkiniz bulunmuyor.
      </Typography>
      <Button component={Link} to="/admin" variant="contained">
        Giriş Sayfasına Dön
      </Button>
    </Box>
  );
};

export default Unauthorized;
